import React, { useState, useEffect } from 'react';
import GoogleMapReact from 'google-map-react';
import PropTypes from 'prop-types';
import ReactSVG from 'react-svg';
import map_marker from 'map_marker.svg';
import ErrorBoundary from './ErrorBoundary';
import CustomAutocomplete from './CustomAutocomplete';

const GOOGLE_MAPS_API_KEY = 'AIzaSyATvnQePj9OTTCZJ6VkugYM8dRGFPJ5HmQ';
const GOOGLE_MAPS_SCRIPT_URL = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places`;

function loadGoogleMapsScript() {
  if (window.google && window.google.maps && window.google.maps.places) {
    return Promise.resolve();
  }

  const existingScript = document.querySelector(
    `script[src="${GOOGLE_MAPS_SCRIPT_URL}"]`
  );

  if (existingScript) {
    return new Promise((resolve, reject) => {
      existingScript.addEventListener('load', resolve);
      existingScript.addEventListener('error', reject);
    });
  }

  const googleMapsScript = document.createElement('script');
  googleMapsScript.src = GOOGLE_MAPS_SCRIPT_URL;
  document.body.append(googleMapsScript);

  return new Promise((resolve, reject) => {
    googleMapsScript.addEventListener('load', resolve);
    googleMapsScript.addEventListener('error', reject);
  });
}

function AutoComplete({
  prefilled_address,
  errors = {},
  placeholder,
  same_as_business,
}) {
  const [address, setAddress] = useState({});

  useEffect(() => {
    if (same_as_business) {
      const autoInput = document.querySelector(
        '.autocomplete-input-container > input'
      );
      // Set React component and hidden input value to null
      setAddress({ name: prefilled_address });
      document.querySelector('#event_address').value = prefilled_address;
      autoInput.setAttribute('disabled', !autoInput.disabled);
      document
        .querySelector('.autocomplete-input-container')
        .classList.toggle('disabled');
    }
  }, [prefilled_address, same_as_business]);

  useEffect(() => {
    if (prefilled_address) {
      setAddress({ name: prefilled_address });
    } else {
      return undefined;
    }

    let isMounted = true;

    const fetchCoords = async () => {
      await loadGoogleMapsScript();

      if (!isMounted) return;

      const service = new window.google.maps.places.PlacesService(
        new window.google.maps.Map(document.querySelector('#map'))
      );
      service.findPlaceFromQuery(
        {
          fields: ['formatted_address', 'geometry.location'],
          query: prefilled_address,
        },
        results => {
          if (isMounted && results && results[0]) {
            setAddress(results[0]);
          }
        }
      );
    };

    fetchCoords();

    return () => {
      isMounted = false;
    };
  }, [prefilled_address]);

  const hasAddressError = errors.address && errors.address[0];

  return (
    <div
      className={`autocomplete-input-container ${
        hasAddressError ? 'error-field' : ''
      }`}
    >
      <CustomAutocomplete
        apiKey={GOOGLE_MAPS_API_KEY}
        onPlaceSelected={place => {
          setAddress(place);
          const inputAddress = place.formatted_address
            ? place.formatted_address
            : place.name;
          if ($('input#listing_address').length) {
            $('input#listing_address').val(inputAddress);
          } else if ($('input#event_address').length) {
            $('input#event_address').val(inputAddress);
          }
        }}
        defaultValue={address.formatted_address || address.name}
        types={['address']}
        placeholder={placeholder}
        componentRestrictions={{ country: 'us' }}
        aria-label="Address Input"
      />
      {address.geometry && (
        <section className="listing-map-container">
          {/* <div className="map-cover" /> */}
          <GoogleMapReact
            bootstrapURLKeys={{
              // @TODO: Add this to an environment variable or something
              key: GOOGLE_MAPS_API_KEY,
            }}
            center={{
              lat: address.geometry.location.lat(),
              lng: address.geometry.location.lng(),
            }}
            defaultZoom={12}
            gestureHandling={false}
            zoomControl={false}
          >
            <ReactSVG
              src={map_marker}
              className="listing-map-marker"
              lat={address.geometry.location.lat()}
              lng={address.geometry.location.lng()}
            />
          </GoogleMapReact>
        </section>
      )}
      {/* !!! IMPORTANT !!!  */}
      <div id="map" />{' '}
      {/* This is necessary for the prefilled map to show up */}
      {/* !!! IMPORTANT !!!  */}
    </div>
  );
}

AutoComplete.propTypes = {
  prefilled_address: PropTypes.string,
  errors: PropTypes.shape({
    address: PropTypes.arrayOf(PropTypes.string),
  }),
  placeholder: PropTypes.string,
  same_as_business: PropTypes.bool,
};

AutoComplete.defaultProps = {
  prefilled_address: null,
  errors: {},
  placeholder: null,
  same_as_business: false,
};

export default function AutoCompleteWrapper({ ...props }) {
  return (
    <ErrorBoundary>
      <AutoComplete {...props} />
    </ErrorBoundary>
  );
}
